export default {"src":"/_next/static/media/avatar-default.79ba5bf1.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};